<template>
  <div class="">
    <div class="tool">
      <div class="b-container" :class="{'klick_reaktion': 0==klick}"><button @click="neuesSpiel()" title="Neues Spiel">
        <svg height="24px" viewBox="0 0 104 92" >
          <g id="3.Multimedia" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <rect fill="#FF7171" x="0" y="0" width="100" height="88" rx="18"></rect>
            <path d="M37,26.8868147 C37,25.2334391 38.1509965,24.5861607 39.5682678,25.4395396 L67.8692915,42.4803815 C69.2877066,43.3344491 69.2865628,44.719855 67.8692915,45.5732339 L39.5682678,62.6140758 C38.1498526,63.4681434 37,62.8207339 37,61.1668007 L37,26.8868147 Z" id="Layer-2" fill="#FFFFFF"></path>
          </g>
        </svg>
      </button></div>
      <select v-model="art" style="margin-right: 2rem">
        <option>Liegend</option><option>Stehend</option>
      </select>
      <div class="b-container" :class="{'klick_reaktion': 1==klick}"><button @click="undo()" title="Zurück">
        <svg width="24px" viewBox="0 0 48 48" >
          <g fill="rgb(216, 165, 99)">
            <polygon points="5,18 19,6.3 19,29.7"/>
            <path d="M28,14H16v8h12c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v8h3c7.2,0,13-5.8,13-13S35.2,14,28,14z"/>
          </g>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 2==klick}"><button @click="redo()" title="Vorwerts">
        <svg width="24px" viewBox="0 0 48 48" >
          <g fill="rgb(38, 189, 33)">
            <polygon points="43,18 29,6.3 29,29.7"/>
            <path d="M20,14h12v8H20c-2.8,0-5,2.2-5,5s2.2,5,5,5h3v8h-3c-7.2,0-13-5.8-13-13S12.8,14,20,14z"/>
          </g>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 3==klick}"><button @click="gruppe()" title="Paare suchen">
        <svg width="24px" viewBox="0 0 30 30" >
          <path class="st8" d="M16,20l6.5,6.5c0.8,0.8,2.2,0.8,3,0l0,0c0.8-0.8,0.8-2.2,0-3L19,17L16,20z"
            fill="#1F992A" stroke="rgb(74, 74, 252)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
          <circle class="st9" cx="12" cy="12" r="9"
            fill="rgb(214, 214, 252)" stroke="rgb(74, 74, 252)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 4==klick}"><button @click="zug()" title="Hinweis">
        <svg width="24px" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="11" stroke="#1245C6"  fill="none"  stroke-width="2"/>
          <path d="M11,16 L13,16 L13,18 L11,18 L11,16 Z
          M12.61,6.04 C10.55,5.74 8.73,7.01 8.18,8.83 C8,9.41 8.44,10 9.05,10 L9.25,10 C9.66,10 9.99,9.71 10.13,9.33 C10.45,8.44 11.4,7.83 12.43,8.05 C13.38,8.25 14.08,9.18 14,10.15 C13.9,11.49 12.38,11.78 11.55,13.03 C11.55,13.04 11.54,13.04 11.54,13.05 C11.53,13.07 11.52,13.08 11.51,13.1 C11.42,13.25 11.33,13.42 11.26,13.6 C11.25,13.63 11.23,13.65 11.22,13.68 C11.21,13.7 11.21,13.72 11.2,13.75 C11.08,14.09 11,14.5 11,15 L13,15 C13,14.58 13.11,14.23 13.28,13.93 C13.3,13.9 13.31,13.87 13.33,13.84 C13.41,13.7 13.51,13.57 13.61,13.45 C13.62,13.44 13.63,13.42 13.64,13.41 C13.74,13.29 13.85,13.18 13.97,13.07 C14.93,12.16 16.23,11.42 15.96,9.51 C15.72,7.77 14.35,6.3 12.61,6.04 Z" 
          fill="#1D1D1D" stroke="#FF7171" />
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 5==klick}"><button @click="setFaktor(-0.5)">
        <svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
        class="feather feather-plus-square">
        <rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2" ></rect>
        <line x1="6" y1="12" x2="18" y2="12"></line>
        </svg>
      </button></div>
      <div class="b-container" :class="{'klick_reaktion': 6==klick}"><button @click="setFaktor(0.5)">
        <svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
        class="feather feather-plus-square">
        <rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2"></rect>
        <line x1="12" y1="6" x2="12" y2="18"></line>
        <line x1="6" y1="12" x2="18" y2="12"></line>
        </svg>
      </button></div>
    
      <div class="b-container" :class="{'klick_reaktion': 7==klick}"><button @click="chgThema()">
        <svg width="44px" viewBox="0 0 42 24" >
          <polygon  points="0 0 21 0 21 24 0 24" :fill="fillT[thema]"></polygon>
          <polygon  points="21 0 40 0 40 24 21 24" :fill="fillT[1-thema]"></polygon>
          <rect x="1" y="1" width="40" height="22" rx="4" ry="4" fill="none" stroke="#1245C6" stroke-width="2"></rect>
          <path d="M12,17 L14,17 L14,7 L10,7 L10,9 L12,9 L12,17 Z"
                 stroke="#000" fill="#000"></path>
          <path d="M35,15 L31,15 L31,13 L33,13 C34.1,13 35,12.11 35,11 L35,9 C35,7.89 34.1,7 33,7 L29,7 L29,9 L33,9 L33,11 L31,11 C29.9,11 29,11.89 29,13 L29,17 L35,17 L35,15 Z"
                stroke="#000" fill="#000"></path>
        </svg>
      </button></div>
    </div>
    
    <div class="shisen-felder" :style="styFeld" v-for="(zeile, y) in dispFeld" :key="y">
      <span  v-for="(zelle, x) in zeile" :key="x">
        <Stein :bild="zelle.i" :aktiv="zelle.a" :x="x" :y="y+1" :thema="thema" @stein-aktiv="steinAktiviert($event)"/>
      </span>
    </div>

    <div class="tool2" style="width: 1130px;">
      <div class="b-container" :class="{'klick_reaktion': 8==klick}"><button @click="neuStart()" title="Neu starten">
        <svg width="24px" viewBox="0 0 487.622 487.622" >
          <circle style="fill:#65B3AD;" cx="243.811" cy="243.811" r="243.811"/>
          <path style="opacity:0.37;fill:#56A49E;enable-background:new    ;" d="M476.466,316.909L323.967,169.733l-67.121-30.225
            l-31.259-29.287l-6.776,39.59l-60.338,29.387l160.338,164.613l-75,24.379l-84.079-25.73l142.006,138.219
            C384.732,460.451,451.088,397.757,476.466,316.909z"/>
          <path style="fill:#FFFFFF;" d="M243.819,377.401c31.867,0,61.826-12.409,84.359-34.941c22.531-22.533,34.942-52.496,34.942-84.359
            c0-0.002,0,0.001,0-0.001c0-31.866-12.409-61.825-34.942-84.358c-16.023-16.023-36.13-27.103-58.147-32.041
            c-11.949-2.682-24.171-3.5-36.249-2.484l-8.195-28.994l-33.557,34.488l-33.557,34.488l46.646,11.816l46.646,11.816l-9.879-34.947
            c24.214-0.574,47.903,8.651,65.701,26.449c35.161,35.161,35.161,92.373,0,127.533c-35.161,35.161-92.372,35.161-127.532,0
            c-26.47-26.467-33.865-65.72-18.847-99.996l-26.674-11.688c-9.529,21.748-12.341,45.643-8.129,69.096
            c4.314,24.02,15.745,45.867,33.058,63.181C181.995,364.991,211.954,377.401,243.819,377.401z"/>
        </svg>
      </button></div>
      <input class="spiel-data" v-model="save" />
    </div>
  </div>
</template>

<script setup>
import Stein from '@/components/Stein.vue';
import {sd} from '@/helper/ShisenData'
import { ref, computed, onMounted, inject } from 'vue'


const feld = ref([
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}],
  [{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}
  ,{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0},{i:0, a:0}]
]);

let save = ref('');
let art = ref('Stehend');
let faktor = inject('groesse');
let thema = inject('thema');
const fillT = ['#BFB','#FBB'];
const klick = ref(-1);
const emit = defineEmits(['change-groesse', 'change-thema']);

const dispFeld = computed(() => feld.value.slice(1, 9));
const styFeld = computed(() => ({
        height: (faktor.value * 10) + 'px',
        width:  (faktor.value  * 139) + 'px'
      }));


onMounted(() => {
  faktor.value  = parseFloat( ( localStorage.getItem('groesse') || '8'));
  thema.value  = parseFloat( ( localStorage.getItem('thema') || '0'));
  neuesSpiel();
})
  
function neuesSpiel() {
  klick.value = 0;
  setTimeout(() => { klick.value = -1; }, 100);
  const reihe = sd.spiel.map( (w,i) => ({w, s: Math.random()}));
  reihe.sort((a, b) => a.s - b.s);
  const arSave = [];
  let k = 0;
  for( let y = 1; y < 9; y++ ) {
    for( let x = 1; x < 19; x++ ) {
      feld.value[y][x].i = reihe[k++].w;
      arSave.push( sd.code.charAt( sd.index.indexOf( feld.value[y][x].i) ) );
    }
  }
  sd.zuege = [];
  save.value = arSave.join('');
}

function neuStart() {
  klick.value = 8;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( save.value ) {
    let  k = 0;
    for( let y = 1; y < 9; y++ ) {
      for( let x = 1; x < 19; x++ ) {
        feld.value[y][x].i = sd.index[ sd.code.indexOf( save.value.charAt(k++) ) ];
      }
    }
  }
  sd.zuege = [];
}

function steinAktiviert(arg) {
  if ( sd.stein ) {
    if ( sd.stein.x === arg.x && sd.stein.y === arg.y ) {
      feld.value[arg.y][arg.x].a = 0;
      sd.stein = null;
      return;
    } else if ( sd.stein.i !== arg.i ) {
      feld.value[sd.stein.y][sd.stein.x].a = 0;
      sd.stein = null;
    } else {
      if ( sd.paar3Linien(feld.value, sd.stein, arg, 0, '') ) {
        const aend = [];
        if ( sd.zuege.length > sd.idx ) {
          sd.zuege.splice(sd.idx);
        }
        sd.zuege.push(aend);
        sd.idx = sd.zuege.length;
        aend.push(
          {x: sd.stein.x, y: sd.stein.y, i: feld.value[sd.stein.y][sd.stein.x].i },
          {x: arg.x, y: arg.y, i: feld.value[arg.y][arg.x].i }
        );
        feld.value[sd.stein.y][sd.stein.x].a = 0;
        feld.value[sd.stein.y][sd.stein.x].i = 0;
        feld.value[arg.y][arg.x].a = 0;
        feld.value[arg.y][arg.x].i = 0;
        if ( art.value === 'Stehend') {
          let x = sd.stein.x;
          let y = (arg.x === sd.stein.x ? Math.min( sd.stein.y, arg.y) : sd.stein.y) - 1;
          for ( ; y > 0 && feld.value[y][x].i > 0; y--) {
            aend.push(
              {x: x, y: y, i: feld.value[y][x].i }
            );
            feld.value[y + 1][x].i = feld.value[y][x].i;
            feld.value[y][x].i = 0;
          }
          x = arg.x;
          y = (arg.x === sd.stein.x ? Math.max( sd.stein.y, arg.y) : arg.y) - 1;
          for ( ; y > 0 && feld.value[y][x].i > 0; y--) {
            aend.push(
              {x: x, y: y, i: feld.value[y][x].i }
            );
            feld.value[y + 1][x].i = feld.value[y][x].i;
            feld.value[y][x].i = 0;
          }
        }
        sd.stein = null;
        return;
      }
      feld.value[sd.stein.y][sd.stein.x].a = 0;
    }
  }
  sd.stein = arg;
  feld.value[arg.y][arg.x].a = 1 ;
}

function undo() {
  klick.value = 1;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( sd.idx > 0 ) {
    sd.idx--;
    const aend = [].concat(sd.zuege[sd.idx]).reverse();
    aend.forEach( item => {
      feld.value[item.y][item.x].i = item.i;
    });
  }
}

function redo() {
  klick.value = 2;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( sd.idx < sd.zuege.length ) {
    const aend = sd.zuege[sd.idx];
    aend.forEach( (item, idx) => {
      feld.value[item.y][item.x].i = 0;
      if ( idx > 1) {
        feld.value[item.y + 1][item.x].i = item.i;
      }
    });
    sd.idx++;
  }

}

function gruppe() {
  klick.value = 3;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( !sd.stein ) {
    return;
  }
  const pos = sd.getPos(sd.stein.i, feld.value);
  pos.forEach( p => { feld.value[p.y][p.x].a = 1; });
  setTimeout( () => {
    pos.forEach( p => { feld.value[p.y][p.x].a = 0; });
    feld.value[sd.stein.y][sd.stein.x].a = 1;
  }, 1500);
}

function zug(){
  klick.value = 4;
  setTimeout(() => { klick.value = -1; }, 100);
  if ( sd.stein ) {
    feld.value[sd.stein.y][sd.stein.x].a = 0;
    sd.stein = null;
  }
  let posZ = null, pos = null, sc;
  for( let y = 1; y < 10 && !posZ; y++ ) {
    for( let x = 1; x < 19 && !posZ; x++ ) {
      if ( feld.value[y][x].i ) {
        sc = { x: x, y: y, i: feld.value[y][x].i};
        pos = sd.getPos(sc.i, feld.value);
        if ( sd.gleich( sc, pos[0] )) {
          if ( sd.paar3Linien(feld.value, pos[0], pos[1], 0, '') ) {
            posZ = [pos[0], pos[1]];
          } else if ( pos.length > 2) {
            if ( sd.paar3Linien(feld.value, pos[0], pos[2], 0, '') ) {
              posZ = [pos[0], pos[2]];
            } else if ( sd.paar3Linien(feld.value, pos[0], pos[3], 0, '') ) {
              posZ = [pos[0], pos[3]];
            }
          }
        } else if (pos.length > 2 && sd.gleich( sc, pos[1] )) {
          if ( sd.paar3Linien(feld.value, pos[1], pos[2], 0, '') ) {
            posZ = [pos[1], pos[2]];
          } else if ( sd.paar3Linien(feld.value, pos[1], pos[3], 0, '') ) {
            posZ = [pos[1], pos[3]];
          }
        } else if (pos.length > 2 && sd.gleich( sc, pos[2] )) {
          if ( sd.paar3Linien(feld.value, pos[2], pos[3], 0, '') ) {
            posZ = [pos[2], pos[3]];
          }
        }
      }
    }
  }
  if ( posZ ) {
    posZ.forEach( p => { feld.value[p.y][p.x].a = 1; });
    setTimeout( () => {
      posZ.forEach( p => { feld.value[p.y][p.x].a = 0; })
    }, 1500);
  } else {
    alert('Keine Züge gefunden!');
  }
}

function setFaktor(f) {
  klick.value = f==0.5 ? 6 : 5;
  setTimeout(() => { klick.value = -1; }, 100);
  emit('change-groesse', f)
}

function chgThema() {
  klick.value = 7;
  setTimeout(() => { klick.value = -1; }, 100);
  emit('change-thema', 1 - thema.value);
}
</script>

